import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import TVPage from "./pages/TVPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminUrunler from "./pages/AdminUrunler";
import AdminDuyurular from "./pages/AdminDuyurular";
import AdminParametreler from "./pages/AdminParametreler";
import AdminResimler from "./pages/AdminResimler";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tv" element={<TVPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminUrunler />} />
            <Route path="urunler" element={<AdminUrunler />} />
            <Route path="duyurular" element={<AdminDuyurular />} />
            <Route path="parametreler" element={<AdminParametreler />} />
            <Route path="resimler" element={<AdminResimler />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
